import { render } from "./Shonin.vue?vue&type=template&id=2fb2b9aa&scoped=true"
import script from "./Shonin.vue?vue&type=script&lang=js"
export * from "./Shonin.vue?vue&type=script&lang=js"

import "./Shonin.vue?vue&type=style&index=0&id=2fb2b9aa&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2fb2b9aa"

export default script